import { Form, FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { Wrapper } from '@ahmdigital/ui';
import React, { useEffect } from 'react';

import RefinePriceFormFields from '../../../../refine-price/form/refine-price-form-fields';
import StepFooterNavigation from '../../../components/step-footer-navigation';

type Props = {
  captureFormState: {
    setFormikErrors: (errors: FormikErrors<any>) => void;
    setFormikTouched: (touched: FormikTouched<any>) => void;
  };
};

const AboutYouForm = ({ captureFormState }: Props) => {
  const { errors, handleSubmit, submitCount, touched } = useFormikContext();
  const setFormikTouched = captureFormState?.setFormikTouched;
  const setFormikErrors = captureFormState?.setFormikErrors;

  // ErrorSummary component requires formik context values. This allows us to pass the errors and touched objects outside the LeadCaptureForm
  useEffect(() => {
    if (setFormikErrors) {
      setFormikErrors(errors);
    }
  }, [errors, setFormikErrors]);

  useEffect(() => {
    if (setFormikTouched) {
      setFormikTouched(touched);
    }
  }, [touched, setFormikTouched]);

  return (
    <Form onSubmit={handleSubmit}>
      <Wrapper size="small">
        <RefinePriceFormFields hasSubmitAttempt={Boolean(submitCount)} showPaymentFrequency={false} />
      </Wrapper>

      <StepFooterNavigation onNextClick={handleSubmit} />
    </Form>
  );
};

export default AboutYouForm;
